import FilePicker, { FilePickerProps } from '../../../../../../components/common/FilePicker';
import MarkerText from '../../../../../components/inputs/MarkerText';
import { useSearchContext } from '../../../context/SettingsSearchContext';

export default function SettingsFilePickerElement(props: Omit<FilePickerProps, 'title'> & { title: string }) {
    const context = useSearchContext();
    return <FilePicker {...props} title={<MarkerText highlight={context.term}>{props.title}</MarkerText>} className="px-3" />;
}
